import { Empty } from "@/@client/Theasoft_ApiServer__Utils_TreeBase"
import { TreePillsInput, TreePillsInputProps } from "./tree/tree-pills-input"
import { useGetProductionTree } from "@/orval/gen/api/production/production"
import { t } from "i18next"

export interface ProductionTreeSelectProps
  extends Omit<TreePillsInputProps<Empty>, "tree"> {}

export function ProductionTreeSelect(props: ProductionTreeSelectProps) {
  const { data } = useGetProductionTree()

  return (
    <TreePillsInput
      label={t("Productions")}
      {...data}
      tree={data?.tree ?? []}
      {...props}
    />
  )
}
